/**
 * Parse a url string into it's parts
 * @param {string} url
 * @returns {URLLike} a tag with parsed url parts
 */
var parseUrl = function parseUrl(url) {
  var a = document.createElement('a');
  a.href = url;
  return a;
};

export default parseUrl;